export default __webpack_public_path__ + "static/media/LogoBillPreview.30e622e6.jpg";